export default "__VITE_ASSET__n1qyvFri__"